// to store the API URL
import axios from 'axios';
// LOCAL
// export const API_Base = "http://127.0.0.1:8100";
export const API_Base = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://127.0.0.1:8100' : 'https://sincroteam.it');
// export const API_Base = "https://sincroteam.it";

// User profile endpoints
export const getUserProfile = async (userId) => {
    try {
        const token = sessionStorage.getItem('access_token');
        const response = await axios.get(`${API_Base}/users/${userId}/profile/`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};